module.exports = __webpack_public_path__ + "img/ci-pooq-white.d769df80.png";